<template>

  <li
    class="list-group-item move"
    :class="{'sortable-disabled': fixed}">
    <div class="d-flex">
        <div
          v-if="!fixed"
          class="mr-2">
          <i class="fas fa-arrows-alt" />
        </div>
        <div class="mr-auto">{{ value.stage_id.name }}</div>
        <div>
          <div v-if="resourceAvailability.features.includes('automated_triggers')">
            <button
              type="button"
              class="btn btn-sm btn-link"
              v-if="!actionsLength"
              @click="showActions = true"><i class="fas fa-bolt"></i> {{ $t('Add actions') }}</button>
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              v-if="actionsLength"
              @click="showActions = true"><i class="fas fa-bolt"></i> {{ $tc('n_actions', actionsLength) }}</button>
          </div>
          <div v-if="!resourceAvailability.features.includes('automated_triggers')">
            <span v-tooltip="'Faça upgrade do plano'"><button
              type="button"
              class="btn btn-sm btn-link"
              style="pointer-events: none;"><i class="fas fa-bolt"></i> {{ $t('Add actions') }}</button></span>
          </div>
          <StageActionForm
            @cancel="showActions = false"
            :value="value.actions"
            @input="updateActions"
            v-if="showActions" />
        </div>
        <div
          v-if="!fixed"
          class="ml-2">
          <button
            type="button"
            class="btn btn-sm btn-link"
            @click="removeStage"><i class="far fa-trash-alt" /></button>
        </div>
    </div>
  </li>

</template>


<script>
import StageActionForm from '@/components/Stage/StageActionForm'

export default {
  name: 'JobFormStages',
  components: {
    StageActionForm
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showActions: false
    }
  },
  computed: {
    actionsLength () {
      return this.value.actions ? this.value.actions.length : 0
    },
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    }
  },
  watch: {
  },
  created () {
  },
  methods: {
    removeStage () {
      this.$emit('remove')
    },
    updateActions (actions) {
      this.showActions = false
      this.$emit('input', {
        ...this.value,
        actions
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.move{
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobFormStages2Item.vue